import React from 'react';
import {
  ReceiptLong as ReceiptLongIcon,
  AddTask as AddTaskIcon,
  Dashboard as DashboardIcon,
  RequestQuote as DepartmentIcon,
} from '@mui/icons-material';
import AddCommentIcon from '@mui/icons-material/AddComment';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import ClaimsSwitch from './ClaimsSwitch';
import ClaimsReport from './ClaimsReport';
import OutPatient from './OutPatient';

const MENU_ITEMS = [
  { key: 'Home',           label: 'Home',          icon: <ReceiptLongIcon />, component: Home },
  // ClaimsSwitch, not HospitalClaims directly: it asks the server which Claims
  // interface this facility should get (standard or premium) and renders that
  // one. Falls back to the standard screen on any failure.
  { key: 'HospitalClaims', label: 'Claims',        icon: <AddTaskIcon />,      component: ClaimsSwitch },
  { key: 'ClaimsReport',   label: 'Claims Report', icon: <DashboardIcon />,    component: ClaimsReport },
  { key: 'OutPatient',     label: 'Documentation', icon: <AddCommentIcon />,   component: OutPatient },
];

export default function Claims() {
  return (
    <DepartmentLayout
      departmentId={30}
      departmentName="Hospital Claims"
      departmentIcon={<DepartmentIcon />}
      menuItems={MENU_ITEMS}
    />
  );
}
